// Check if video and audio are on in simple video
export const checkAudioVideoEnabled = () => {
  const params = new URLSearchParams(window.parent.location.search);
  const isVideoEnabled = params.get('video-enabled') !== 'false';
  const isAudioEnabled = params.get('audio-enabled') !== 'false';

  return { isVideoEnabled, isAudioEnabled };
};
